import styled, { css } from 'styled-components';

export const SidebarNodeContainer = styled.div`
  margin-bottom: 6px;
`;

export const SidebarNodeBox = styled.div<{ cursorPointer: boolean }>`
  padding: 12px 0;
  cursor: ${({ cursorPointer }) => (cursorPointer ? 'pointer' : 'default')};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const SidebarNodeBoxLink = styled.a`
  padding: 12px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
`;

export const SibebarNodeLabel = styled.div<{
  active: boolean;
  opened: boolean;
}>`
  font-style: normal;
  font-size: 16px;
  flex: 1;
  line-height: 20px;
  margin-left: 8px;

  ${({ theme, active, opened }) => css`
    color: ${active ? theme.sidebar.node.active : theme.sidebar.node.color};
    font-weight: ${active || opened ? 'bold' : 'normal'};
  `}
`;

export const SibebarNodeContent = styled.div<{
  opened: boolean;
  maxHeight: number;
}>`
  padding-left: 32px;
  height: ${({ maxHeight }) => maxHeight}px;
  transition: all 0.3s;
  overflow: hidden;

  ${({ opened }) =>
    !opened &&
    css`
      transition: all 0.3s;
      height: 0;
    `}
`;

export const IconContainer = styled.div<{ isOpen: boolean }>`
  transform-origin: center;
  transition: transform 0.35s;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
